import { TBaseItem } from "@centricsoftware/design-system";
import { goToDialogAggregateStore } from "csi/middleware/goToDialog/goToDialogService";
import { StoreNames } from "csi/store/Names";
import { createContext, useContext } from "react";
import { GoToDialogSave, OnLoadOptions, SelectStoreBase } from "./SelectStoreBase";

export class SingleSelectStore extends SelectStoreBase {
	/** value representing the transientInfo.value of the single select */
	singleSelectValue: string = "";

	/** onChange handler for the single select */
	updateSingleSelectValue = (value: string): void => {
		this.singleSelectValue = value;
	};

	/** callback when list action is clicked */
	onListActionClick = (): void => {
		const { aggregateStore, aggregateStore: { aggregateStoreParams }, goToDialogSave, invalidItems, label, singleSelectValue } = this;
		goToDialogAggregateStore(
			aggregateStore,
			aggregateStoreParams.sourceUrl,
			[singleSelectValue],
			invalidItems,
			false,
			label,
			goToDialogSave,
		);
	};

	constructor(aggregateStore: StoreNames, onLoadOptions: OnLoadOptions, label: string, goToDialogSave?: GoToDialogSave, enumFormData?: FormData, options?: TBaseItem[], value?: string) {
		super(aggregateStore, onLoadOptions, label, goToDialogSave, enumFormData, options);
		this.singleSelectValue = value;
	}
}

export const SingleSelectStoreContext = createContext<SingleSelectStore>(undefined);
export const useSingleSelectStore = (): SingleSelectStore => useContext(SingleSelectStoreContext);